/**
 * extractWordText — extrae el texto plano de un .docx en el navegador (mammoth)
 * para que ARIA lo lea como contexto. No crea ocr_scan ni gasto: el texto se
 * antepone al mensaje del usuario. mammoth se carga de forma perezosa.
 */

export const WORD_ACCEPTED_TYPES = [
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
];

// Tope del texto inyectado al prompt (caracteres) para no inflar tokens.
export const WORD_TEXT_CAP = 12_000;

export function isWordFile(file) {
  if (!file) return false;
  return WORD_ACCEPTED_TYPES.includes(file.type) || /\.docx$/i.test(file.name || '');
}

/**
 * @returns {Promise<string>} texto plano (recortado a WORD_TEXT_CAP).
 */
export async function extractWordText(file) {
  if (!isWordFile(file)) throw new Error('Formato no admitido. Usa Word (.docx).');
  const mammoth = await import('mammoth/mammoth.browser');
  const arrayBuffer = await file.arrayBuffer();
  const { value } = await mammoth.extractRawText({ arrayBuffer });
  const text = String(value || '').trim();
  if (!text) throw new Error('El documento Word no contiene texto legible.');
  return text.length > WORD_TEXT_CAP ? `${text.slice(0, WORD_TEXT_CAP)}\n…(documento recortado)` : text;
}
